<div
    (fileDropped)="uploadFile($event)"
    class="relative"
    [ngClass]="{'cursor-pointer': !disabled}"
    (click)="onContainerClick()"
    app-drag-and-drop>
    <input
        [disabled]="disabled"
        #fileInput
        (change)="uploadFile(fileInput.files)"
        [accept]="acceptTypes"
        [multiple]="false"
        class="absolute h-0 w-0 opacity-0 invisible pointer-events-none"
        id="file-input"
        type="file">
    <div @zoomIn (click)="fileInput.click()" *ngIf="backgroundImage" [ngClass]="styling"
         class="artwork-container flex justify-center border border-dashed border-accent-300 dark:border-accent-800">
        <img [ngClass]="styling" alt="Artwork" class="object-contain" src="{{backgroundImage}}"/>
    </div>
    <div (click)="fileInput.click()" *ngIf="!backgroundImage"
         [ngClass]="{'hover:border-accent-500 hover:text-accent-500': !disabled}"
         [class]="'artwork-placeholder flex justify-center border-2 border-dashed border-gray-300 rounded text-hint ' + styling">
        <div class="inline-flex m-auto text-xl font-bold text-center select-none p-4">{{processing ? ('status-processing-ellipsis' | transloco) : text}}
            <mat-progress-spinner *ngIf="processing" [diameter]="24" [mode]="'indeterminate'"
                class="ml-2">
            </mat-progress-spinner>
        </div>

    </div>
    <div *ngIf="uploadStatus && uploadStatus.state !== 'PENDING'" class="absolute h-full w-full left-0 top-0 bg-primary bg-opacity-30 transition-transform" [ngStyle]="{'transform-origin': 'left', 'transform': 'scaleX('+(uploadStatus?.progress / 100 ?? 0)+')'} "></div>
    <mat-progress-bar
        *ngIf="uploadStatus && uploadStatus.state === 'PENDING'"
        [mode]="uploadStatus.state == 'PENDING' ? 'buffer' : 'determinate'"
        [value]="uploadStatus.progress"
        class="mt-2"
    >
    </mat-progress-bar>
</div>
